import { rootCauses, getScoreColor, PL } from "@/lib/reportUtils";

const SUBSTAGE_LABEL = {
  raw_material_extraction: "Raw Material — Extraction",
  raw_material_processing: "Raw Material — Processing",
  manufacturing_pre_processing: "Manufacturing — Pre-Processing",
  manufacturing_production: "Manufacturing — Production",
  use_phase_operation: "Use Phase — Operation",
  use_phase_maintenance: "Use Phase — Maintenance",
  eol_recycling: "End-of-Life — Recycling",
  eol_recovery: "End-of-Life — Recovery",
  eol_disposal: "End-of-Life — Disposal",
  logistics_transportation: "Supply Chain — Transportation",
  logistics_storage: "Supply Chain — Storage",
};
const STAGE_LABEL = {
  raw_material: "Raw Material", manufacturing: "Manufacturing",
  use_phase: "Use Phase", end_of_life: "End-of-Life", logistics: "Logistics",
};

export const RootCauseAnalysis = ({ results, paramsByStage, mode }) => {
  const scoreScale = mode === "advanced" ? 10 : 1;
  let causes;
  if (mode === "advanced") {
    // advanced: by substage (use ssi + parameter_scores substage keyed)
    const ssi = results?.ssi || {};
    const substageParams = results?.parameter_scores || {};
    causes = rootCauses(substageParams, ssi, 5).map((c) => ({
      ...c, label: SUBSTAGE_LABEL[c.key] || c.key,
    }));
  } else {
    const si = results?.stage_si || {};
    causes = rootCauses(paramsByStage, si, 5).map((c) => ({
      ...c, label: STAGE_LABEL[c.key] || c.key,
    }));
  }

  return (
    <div data-testid="root-cause-analysis">
      {causes.length === 0 ? (
        <div className="p-4 rounded-lg bg-[#43A047]/5 border border-[#43A047]/30">
          <p className="text-[12px] text-[#1B291D]">✅ No weak {mode === "advanced" ? "substages" : "stages"} (all score ≥ {5 * scoreScale}). Root-cause analysis not required.</p>
        </div>
      ) : (
        <div className="root-cause-list space-y-2">
          <p className="text-[11px] text-[#617364] mb-1 italic">
            For each underperforming {mode === "advanced" ? "substage" : "stage"} (score &lt; {5 * scoreScale}), the 2 weakest parameters — these are the root causes.
          </p>
          {causes.map((c) => (
            <div key={c.key} className="root-cause-card rounded-lg border border-[#D32F2F]/30 bg-[#D32F2F]/5 p-3">
              <div className="flex items-start justify-between gap-3 mb-2">
                <div>
                  <p className="text-[12px] font-semibold text-[#1B291D]">{c.label}</p>
                  <p className="text-[10px] text-[#617364]">Overall score: <strong style={{ color: getScoreColor(c.score) }}>{(c.score * scoreScale).toFixed(2)}</strong></p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {c.drivers.map((d) => (
                  <div key={d.pk} className="root-cause-driver p-2 rounded bg-white border border-[#E0E6E1]">
                    <div className="flex items-center justify-between mb-0.5">
                      <span className="text-[10px] uppercase tracking-wider font-bold text-[#D32F2F]">⚠️ Root Cause</span>
                      <span className="text-[11px] font-bold" style={{ color: getScoreColor(d.adj) }}>{(d.adj * scoreScale).toFixed(2)}</span>
                    </div>
                    <p className="text-[11px] text-[#1B291D]">{PL[d.pk]}</p>
                  </div>
                ))}
              </div>
              <p className="text-[10px] text-[#617364] italic mt-2">
                Weakness driven by <strong>{c.drivers.map((d) => PL[d.pk]).join(" and ")}</strong> — not environmental factors alone. Targeted improvement on these lifts the entire {mode === "advanced" ? "substage" : "stage"}.
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
